"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableWidthExporter = void 0;
var tslib_1 = require("tslib");
var table_units_1 = require("../../../../../core/model/tables/secondary-structures/table-units");
var translation_tables_1 = require("../../../../translation-table/translation-tables");
var writer_helper_1 = require("../../../utils/writer-helper");
var base_1 = require("../../base");
var TableWidthExporter = (function (_super) {
    tslib_1.__extends(TableWidthExporter, _super);
    function TableWidthExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TableWidthExporter.prototype.exportWidthUnitValue = function (tag, widthUnit) {
        if (!this.forbidExportWidthUnit(widthUnit))
            this.writeTableUnit(tag, widthUnit.value, widthUnit.type);
    };
    TableWidthExporter.prototype.forbidExportWidthUnit = function (widthUnit) {
        return widthUnit.type == table_units_1.TableWidthUnitType.Nil && widthUnit.value == 0;
    };
    TableWidthExporter.prototype.writeTableUnit = function (tag, value, type) {
        this.writer.writeWpStartElement(tag);
        this.writer.writeWpIntAttr('w', value);
        this.writer.writeWpStringAttr('type', writer_helper_1.WriterHelper.getValueFromTables(translation_tables_1.TranslationTables.widthUnitTypesTable, type, table_units_1.TableWidthUnitType.ModelUnits));
        this.writer.endElement();
    };
    return TableWidthExporter;
}(base_1.BaseExporter));
exports.TableWidthExporter = TableWidthExporter;
